export default "Gør som Ask & Liv; snit jeres egne vaskeægte fiskespyd! ";